/*
 * When the shopper's saved collection view is "bulk", collection links on every page carry
 * ?view=bulk-order-collection, so the bulk template loads directly instead of the grid template
 * loading first and collection-view-toggle.liquid redirecting. The toggle's own buttons are
 * excluded: the Grid button must keep its plain URL.
 */
(function () {
  var STORAGE_KEY = 'collectionViewPreference';
  var VIEW_PARAM = 'view';
  var BULK_VIEW_VALUE = 'bulk-order-collection';
  var COLLECTION_PATH = /^\/collections\/[^/]+\/?$/;

  function prefersBulk() {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'bulk';
    } catch (err) {
      return false;
    }
  }

  function addBulkView(anchor) {
    if (anchor.closest('.collection-view-toggle')) return;
    var url;
    try {
      url = new URL(anchor.getAttribute('href'), window.location.href);
    } catch (err) {
      return;
    }
    if (url.origin !== window.location.origin || !COLLECTION_PATH.test(url.pathname)) return;
    if (url.searchParams.has(VIEW_PARAM)) return;
    url.searchParams.set(VIEW_PARAM, BULK_VIEW_VALUE);
    anchor.setAttribute('href', url.pathname + url.search + url.hash);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!prefersBulk()) return;
    document.querySelectorAll('a[href]').forEach(addBulkView);
  });

  // Links rendered after load (predictive search, re-rendered menus) are fixed on the way out.
  document.addEventListener(
    'click',
    function (event) {
      if (!prefersBulk()) return;
      var anchor = event.target.closest && event.target.closest('a[href]');
      if (anchor) addBulkView(anchor);
    },
    true
  );
})();
